import React from 'react';
import { Page } from '../Page';
import { SupplementCallout } from '../SupplementCallout';
import { AlertTriangle } from 'lucide-react';
export function PageAcuteSideEffects() {
  return <Page pageNumber={34} variant="light" data-id="element-1189" data-mp="1rtov7lzfxny8">
      <div className="flex flex-col h-full" data-id="element-1190" data-mp="1rrvok6otv3q8">
        {/* Hero Image */}
        <div className="h-[160px] -mx-12 -mt-10 mb-6 overflow-hidden relative" data-id="element-1191" data-mp="1vvag9um4p8ji">
          <img src="https://images.unsplash.com/photo-1505576399279-565b52d4ac71?w=1000&q=80" alt="Wellness and health" className="w-full h-full object-cover" data-id="element-1192" data-mp="20uenifphsw77" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#F5F5F0] via-[#F5F5F0]/40 to-transparent" data-id="element-1193" data-mp="2ajeryemrkjss" />
        </div>

        <div className="mb-6" data-id="element-1194" data-mp="2fhzuikphnfke">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-2" data-id="element-1195" data-mp="2fl42zu9zkxgv">
            Side Effects
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-1196" data-mp="2ojg1eih3gzjv">
            Acute <span className="text-tealslate" data-id="element-1197" data-mp="2jxeqe2jxrfdz">Side Effects</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-1198" data-mp="2jvacqsw8j20i" />
        </div>

        <div className="mb-6" data-id="element-1199" data-mp="2fv075hccudm6">
          <h2 className="text-xl font-serif text-[#1F1F1F] mb-2" data-id="element-1200" data-mp="2fxw5v7w116bo">
            The First 48 Hours
          </h2>
          <p className="text-sm text-[#3B3B3B] leading-[1.8] max-w-2xl" data-id="element-1201" data-mp="2ayjgoghonn5x">
            Side effects typically peak 24 to 48 hours after your injection.
            This is when the medication concentration in your blood is highest.
            Plan your injection day accordingly. Many people prefer Friday
            evenings so they can manage any acute symptoms over the weekend.
          </p>
        </div>

        <div className="space-y-3 mb-6" data-id="element-1202" data-mp="2owrbahr8ycdx">
          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 flex items-start gap-4" data-id="element-1203" data-mp="2ovoke9txc9y0">
            <div className="w-8 h-8 rounded-full bg-burgundy flex items-center justify-center shrink-0 mt-0.5" data-id="element-1204" data-mp="3mcx0na9bfigo">
              <AlertTriangle className="w-4 h-4 text-white" data-id="element-1205" data-mp="3hjkfxb7rbvt7" />
            </div>
            <div data-id="element-1206" data-mp="1foo1l2mnaga1">
              <h3 className="text-sm font-bold text-[#1F1F1F] mb-1" data-id="element-1207" data-mp="1fo4uyi2g3ebb">Nausea</h3>
              <p className="text-xs text-[#7A7A70] leading-[1.6] mb-1.5" data-id="element-1208" data-mp="1jo57fx5zhffq">
                The most common side effect. It is usually caused by eating too
                much, eating too fast, or eating high-fat/fried foods.
              </p>
              <p className="text-[11px] text-[#7A7A70]" data-id="element-1209" data-mp="1aus4s3i4azgg">
                <strong className="text-[#1F1F1F]" data-id="element-1210" data-mp="vykm57mcy63a">Tips:</strong> Eat slowly,
                avoid greasy/heavy foods, try smaller meals. Ginger tea or
                ginger supplements can help.
              </p>
            </div>
          </div>

          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 flex items-start gap-4" data-id="element-1211" data-mp="n1abnohd6kzf">
            <div className="w-8 h-8 rounded-full bg-burgundylight flex items-center justify-center shrink-0 mt-0.5" data-id="element-1212" data-mp="s04v8sn5odkl">
              <AlertTriangle className="w-4 h-4 text-white" data-id="element-1213" data-mp="2mc1n2mpiflg6" />
            </div>
            <div data-id="element-1214" data-mp="2m9yze9bty4em">
              <h3 className="text-sm font-bold text-[#1F1F1F] mb-1" data-id="element-1215" data-mp="2wfzznzhwto2k">
                Diarrhea
              </h3>
              <p className="text-xs text-[#7A7A70] leading-[1.6] mb-1.5" data-id="element-1216" data-mp="2rh5eiqwgznfa">
                Often occurs when you consume too much fat or sugar in a single
                sitting. The medication slows digestion, but excess fat can
                cause a rapid emptying effect.
              </p>
              <p className="text-[11px] text-[#7A7A70]" data-id="element-1217" data-mp="3f67yw6ihnudh">
                <strong className="text-[#1F1F1F]" data-id="element-1218" data-mp="3f4n3keoco7ek">Tips:</strong> Stay hydrated,
                increase soluble fiber gradually, avoid sugar alcohols and
                artificial sweeteners.
              </p>
            </div>
          </div>

          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 flex items-start gap-4" data-id="element-1219" data-mp="3k5ucwi655enc">
            <div className="w-8 h-8 rounded-full bg-tealslate flex items-center justify-center shrink-0 mt-0.5" data-id="element-1220" data-mp="1tsvdof8f75pr">
              <AlertTriangle className="w-4 h-4 text-white" data-id="element-1221" data-mp="1ps1t9vu6s91m" />
            </div>
            <div data-id="element-1222" data-mp="1r8p7s208x56k">
              <h3 className="text-sm font-bold text-[#1F1F1F] mb-1" data-id="element-1223" data-mp="1r98kn4b1h3dq">
                Constipation
              </h3>
              <p className="text-xs text-[#7A7A70] leading-[1.6] mb-1.5" data-id="element-1224" data-mp="1w6qvj08m9sod">
                The direct result of slowed gastric emptying. If left unmanaged,
                it can become severe.
              </p>
              <p className="text-[11px] text-[#7A7A70]" data-id="element-1225" data-mp="2576r7nj4bvio">
                <strong className="text-[#1F1F1F]" data-id="element-1226" data-mp="18ihcu76p9l1g">Tips:</strong> Increase fiber
                intake (with meals), stay hydrated, consider a magnesium
                supplement.
              </p>
            </div>
          </div>
        </div>

        <div className="flex-1 flex items-end" data-id="element-1227" data-mp="1hhcjfkdnox5a">
          <div className="w-full" data-id="element-1228" data-mp="1m9cdiw71ovty">
            <SupplementCallout title="GI Support" description="Ginger supplements can help manage nausea. Magnesium citrate supports regularity. Both are well-tolerated and evidence-based options before reaching for prescription medications." data-id="element-1229" data-mp="1manp3i6qf7vm" />
          </div>
        </div>
      </div>
    </Page>;
}